import useLayout from "@/lib/layout/useLayout";
import { useEffect } from "react";
import {
    faChartBar,
    faChartLine,
    faGear,
    faImage,
    faPrescription,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Divider, Tab, Tabs } from "@heroui/react";
import {
    createFileRoute,
    Link,
    Outlet,
    useMatch,
} from "@tanstack/react-router";
import useAuth from "@/lib/auth/useAuth";
import useFeatureFlags from "@/lib/featureFlags/useFeatureFlags";
import { Translation } from "react-i18next";

export const Route = createFileRoute("/dashboard/home")({
    component: RouteComponent,
});

function RouteComponent() {
    const { userIsSentinel } = useAuth();
    const { setLayoutState } = useLayout();
    const { bulkRxEnabled, virtualSIEnabled, fieldConfigEnabled } =
        useFeatureFlags();
    useEffect(() => {
        setLayoutState("full_screen");
    }, [setLayoutState]);

    const dashboard = useMatch({
        from: "/dashboard/home/dashboard",
        shouldThrow: false,
    });
    const imageryQaQc = useMatch({
        from: "/dashboard/home/imagery-qaqc",
        shouldThrow: false,
    });
    const syncedOperations = useMatch({
        from: "/dashboard/home/synced-operations",
        shouldThrow: false,
    });
    const bulkRx = useMatch({
        from: "/dashboard/home/bulk-rx",
        shouldThrow: false,
    });
    const virtualSi = useMatch({
        from: "/dashboard/home/virtual-si",
        shouldThrow: false,
    });
    const fieldConfig = useMatch({
        from: "/dashboard/home/field-config",
        shouldThrow: false,
    });

    const tab = [
        dashboard,
        imageryQaQc,
        syncedOperations,
        bulkRx,
        virtualSi,
        fieldConfig,
    ]
        ?.find((x) => !!x)
        ?.fullPath?.split("/")
        .pop();

    return (
        <div className="flex flex-col  overflow-hidden h-full">
            <Tabs variant="underlined" color="primary" selectedKey={tab}>
                <Tab
                    key="dashboard"
                    as={Link}
                    // @ts-expect-error ts(2322)
                    to="/dashboard/home/dashboard"
                    title={
                        <div className="flex flex-row items-center gap-2">
                            <FontAwesomeIcon icon={faChartBar} size="sm" />
                            <Translation ns="home-dashboard">
                                {(t) => t("dashboard")}
                            </Translation>
                        </div>
                    }
                />
                {fieldConfigEnabled && (
                    <Tab
                        key="field-config"
                        as={Link}
                        // @ts-expect-error ts(2322)
                        to="/dashboard/home/field-config"
                        title={
                            <div className="flex flex-row items-center gap-2">
                                <FontAwesomeIcon icon={faGear} size="sm" />
                                Field Config
                            </div>
                        }
                    />
                )}
                {userIsSentinel && (
                    <>
                        <Tab
                            key="imagery-qaqc"
                            as={Link}
                            // @ts-expect-error ts(2322)
                            to="/dashboard/home/imagery-qaqc"
                            title={
                                <div className="flex flex-row items-center gap-2">
                                    <FontAwesomeIcon icon={faImage} size="sm" />
                                    Imagery QA
                                </div>
                            }
                        />
                        {/* <Tab
                            key="synced-operations"
                            as={Link}
                            // @ts-expect-error ts(2322)
                            to="/dashboard/home/synced-operations"
                            title={
                                <div className="flex flex-row items-center gap-2">
                                    <FontAwesomeIcon icon={faSync} size="sm" />
                                    Synced Operations
                                </div>
                            }
                        /> */}
                        {bulkRxEnabled && (
                            <Tab
                                key="bulk-rx"
                                as={Link}
                                // @ts-expect-error ts(2322 )
                                to="/dashboard/home/bulk-rx"
                                title={
                                    <div className="flex flex-row items-center gap-2">
                                        <FontAwesomeIcon
                                            icon={faPrescription}
                                            size="sm"
                                        />
                                        Bulk Export Rx
                                    </div>
                                }
                            />
                        )}
                        {virtualSIEnabled && (
                            <Tab
                                key="virtual-si"
                                as={Link}
                                // @ts-expect-error ts(2322)
                                to="/dashboard/home/virtual-si"
                                title={
                                    <div className="flex flex-row items-center gap-2">
                                        <FontAwesomeIcon
                                            icon={faChartLine}
                                            size="sm"
                                        />
                                        Virtual SI
                                    </div>
                                }
                            />
                        )}
                    </>
                )}
            </Tabs>
            <Divider />
            <Outlet />
        </div>
    );
}
